(function() {
	var collapse = document.querySelectorAll('.bloc-faq');

	collapse.forEach(function(el) {

		el.querySelector('.reponse').setAttribute('hidden', true);

		var btn = el.querySelector('button');
		var target = el.querySelector('.reponse');

		btn.onclick = function() {
			var expanded = btn.getAttribute('aria-expanded') === 'true';
			btn.setAttribute('aria-expanded', !expanded);
			btn.classList.toggle('open');
			target.hidden = expanded;  
		}
	});
})()